(function ($) {
    $(document).ready(function () {

        $('div.the-process-container > div#the-process > div.process-grid-container > div.process-grid .animated-label').each(function (idx, e) {
            var instance = basicScroll.create({
                elem: e,
                from: 'top-bottom',
                to: 'top-middle',
                direct: true,
                props: {
                    '--opacity': {
                        from: .01,
                        to: 2.00
                    }
                }
            });

            instance.start();
        });

        $('div.fact-grid div.fact-grid-panel').each(function (idx, e) {
            var instance = basicScroll.create({
                elem: e,
                from: 'top-bottom',
                to: 'bottom-bottom',
                direct: true,
                props: {
                    '--translate-y': {
                        from: 40 * (idx + 1),
                        to: 0
                    }
                }
            });

            instance.start();
        });

        $('img.animated-image').each(function (idx, e) {
            var instance = basicScroll.create({
                elem: e,
                from: 'top-bottom',
                to: 'top-middle',
                direct: true,
                props: {
                    '--translate-x': {
                        from: 32,
                        to: 0
                    }
                }
            });

            instance.start();
        });

        $('div.content-item').each(function (idx, e) {
            var contentItem = basicScroll.create({
                elem: e,
                from: 'top-bottom',
                to: 'bottom-bottom',
                direct: true,
                props: {
                    '--rotate': {
                        from: 4,
                        to: 0
                    }
                }
            });

            contentItem.start();
        });
    });
})(jQuery);